import { PublishedDoc } from "../dsm/published-doc";
import { PublishedDocPage } from "../dsm/published-doc-page";
import { z } from "zod";
export const PublishedDocsDump = z.object({
    documentation: PublishedDoc,
    pages: PublishedDocPage.array(),
});
